module.exports = __webpack_public_path__ + "img/chevron-right.174e650d.svg";